import React from 'react';

import { Alert } from '@mui/material';

const SECONDS_PER_STEP = 30;

const ClockDriftWarning = ({
  driftSteps,
  onDismiss,
}: {
  driftSteps: number | null;
  onDismiss: () => void;
}) => {
  if (!driftSteps || driftSteps <= 0) return null;

  return (
    <Alert severity="warning" onClose={onDismiss} sx={{ mb: 2 }}>
      {`The clock on your device seems to be ${driftSteps * SECONDS_PER_STEP} seconds ahead of ours. `}
      We recommend resyncing the time on the device before the drift grows enough for the codes to
      stop working.
    </Alert>
  );
};

export default ClockDriftWarning;
